var highlightItemBody, processItemDidChangeAttribute, processItemDidChangeBody, smartLinks, tagsHelper, typesHelper;

smartLinks = require('./smart-links');

typesHelper = require('./types');

tagsHelper = require('./tags');

processItemDidChangeAttribute = function(item, attribute, value, oldValue) {
  var startBodyString;
  startBodyString = item.bodyString;
  if (attribute === 'data-type') {
    typesHelper.syncTypeAttributeToItemBody(item, value, oldValue);
  } else if (tagsHelper.encodesAttributeName(attribute)) {
    tagsHelper.syncTagAttributeToItemBody(item, attribute, value);
  }
  if (startBodyString !== item.bodyString) {
    return highlightItemBody(item);
  }
};

processItemDidChangeBody = function(item, oldBody) {
  var bodyString, contentString, newTagMatches, newTags, oldTags, parseResults, results, tag, type;
  oldTags = tagsHelper.parseTags(oldBody).tags;
  newTagMatches = [];
  parseResults = tagsHelper.parseTags(item.bodyString, function(tag, value, match) {
    return newTagMatches.push({
      tag: tag,
      value: value,
      match: match
    });
  });
  newTags = parseResults.tags;
  bodyString = item.bodyString;
  if (parseResults.trailingMatch) {
    contentString = bodyString.substr(0, bodyString.length - parseResults.trailingMatch[0].length);
  } else {
    contentString = bodyString;
  }
  type = typesHelper.parseType(contentString);
  item.setAttribute('data-type', type);
  highlightItemBody(item, type, newTags, newTagMatches, contentString);
  for (tag in oldTags) {
    if (newTags[tag] == null) {
      item.removeAttribute(tag);
    }
  }
  results = [];
  for (tag in newTags) {
    if (newTags[tag] !== oldTags[tag]) {
      results.push(item.setAttribute(tag, newTags[tag]));
    } else {
      results.push(void 0);
    }
  }
  return results;
};

highlightItemBody = function(item, type, tags, tagMatches, contentString) {
  var attributes, bodyString, each, encodedTagName, i, leadingSpace, len, length, match, parseResults, start, tag, value;
  bodyString = item.bodyString;
  if (!tags) {
    tagMatches = [];
    parseResults = tagsHelper.parseTags(bodyString, function(tag, value, match) {
      return tagMatches.push({
        tag: tag,
        value: value,
        match: match
      });
    });
    tags = parseResults.tags;
    if (parseResults.trailingMatch) {
      contentString = bodyString.substr(0, bodyString.length - parseResults.trailingMatch[0].length);
    } else {
      contentString = bodyString;
    }
  }
  for (i = 0, len = tagMatches.length; i < len; i++) {
    each = tagMatches[i];
    tag = each.tag;
    value = each.value;
    match = each.match;
    leadingSpace = match[1];
    start = match.index + leadingSpace.length;
    length = match[0].length - leadingSpace.length;
    item.addBodyHighlightAttributeInRange('tag', tag, start, length);
    encodedTagName = tagsHelper.encodeNameForAttributeName(tag);
    attributes = {
      tagname: tag,
      link: "filter://@" + encodedTagName
    };
    item.addBodyHighlightAttributesInRange(attributes, start, match[2].length + 1);
    if (value != null ? value.length : void 0) {
      attributes = {
        tagvalue: value,
        link: "filter://@" + encodedTagName + " = " + value
      };
      item.addBodyHighlightAttributesInRange(attributes, start + 1 + match[2].length + 1, value.length);
    }
  }
  if (type == null) {
    type = typesHelper.parseType(contentString);
  }
  if (type === 'task') {
    item.addBodyHighlightAttributesInRange({
      link: 'button://toggledone',
      lead: ''
    }, 0, 1);
    if (contentString.length > 2) {
      item.addBodyHighlightAttributeInRange('content', '', 2, contentString.length - 2);
    }
  } else if (type === 'project') {
    if (contentString.length > 1) {
      item.addBodyHighlightAttributeInRange('content', '', 0, contentString.length - 1);
    }
  } else {
    if (contentString) {
      item.addBodyHighlightAttributeInRange('content', '', 0, contentString.length);
    }
  }
  return smartLinks.highlightLinks(item);
};

module.exports = {
  processItemDidChangeBody: processItemDidChangeBody,
  processItemDidChangeAttribute: processItemDidChangeAttribute
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/taskpaper/change-delegate.js
 ** module id = 198
 ** module chunks = 0
 **/